import { isNil } from 'lodash';
import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { expandLeftToolbar } from '../../../action/left-toolbar-state-actions';
import { photoUpdate, photoDeleteRequest as photoDeleteAction } from '../../../action/photo-actions';
import { createContent } from '../commonFunctions';
import {
  infoWindowOpenAction,
  infoWindowCloseAction,
} from '../../../action/infowindow-action';
import ConfirmRemoval from '../../../component/main-ui/left-toolbar/common/confirm-remove/index';
import './photo.css';
import {
  enableMapObject,
  disableMapObject,
} from '../../../action/disable-map-obj-state-action';
import { collapseLeftToolbar } from '../../../action/left-toolbar-state-actions';
import {
  selectedObjectId,
  selectedObjectIdNull,
} from '../../../action/map-object-id';
import sharedCluster, { rebuildCluster } from '../sharedMarkerCluster';
import { contentVisibilityKey } from '../../../action/hidden-content-ids-actions';
import { visibleActiveVendors } from '../../../lib/layerVisibility'

const buildPhotoContent = (url, color) => {
  let colorMarker =
    color.length <= 6 || color.length <= 7
      ? color[0] == '#'
        ? color
        : '#' + color
      : color[0] == '#'
        ? color.substring(2)
        : '#' + color.substring(2);

  const content = document.createElement('div');
  content.classList.add('photo-property');
  content.innerHTML = `
    <div style="height: 30px; width: 30px; border: 2px solid ${colorMarker}; border-radius: 50%; overflow: hidden;margin-bottom: 5px; position: relative;background-color: ${colorMarker}">
      <img style="height: 30px; width: 30px; object-fit: cover; position: absolute; top: 0; left: 0;" src="${url ? url : 'https://images.unsplash.com/photo-1575936123452-b67c3203c357?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8aW1hZ2V8ZW58MHx8MHx8fDA%3D'}" alt="Image">
    </div>
    <div class="triangle-style-mouse-handler" style="border-top: 13px solid ${colorMarker}" ></div>
  `;
  return content;
};

const RenderPhotos = (props) => {
  const [comfirmRemove, setComfirmRemove] = useState(false);
  const [deleteMarkerId, setDeleteMarkerId] = useState('NAN');
  const [infowindowsState, setInfowindowsState] = useState(null);
  const [previousState, setPreviousState] = useState(null);

  const nulTheMapRefPhoto = useRef(null);
  const photoMarkerRefs = useRef({});
  const photoClusterRef = useRef(null);
  const openInfoWindowCloseRef = useRef(null);

  const {
    photos,
    mapReference,
    auth,
    expandLeftToolbar,
    activeVendors,
    vendors,
    infoWindow,
    photoDeleteRequest,
    infoWindowOpenAction,
    collapseLeftToolbar,
    selectedObjectId,
    selectedObjectIdNull,
    hiddenContentTypes,
    hiddenContentIds,
  } = props;

  const token = auth.token;

  const handleRemoveFunction = () => {
    if (nulTheMapRefPhoto.current) {
      nulTheMapRefPhoto.current(deleteMarkerId);
      setComfirmRemove(false);
    }
  };

  useEffect(() => {
    if (previousState) {
      previousState.close();
    }
    setPreviousState(infowindowsState);
  }, [infowindowsState]);

  const storeInfoBox = (value) => {
    setInfowindowsState(value);
    infoWindowOpenAction(value);
  };

  const photoRenderFunction = async (toAdd) => {
    const { AdvancedMarkerElement } = await window.google.maps.importLibrary('marker');

    // Clear previous markers
    Object.values(photoMarkerRefs.current).forEach((marker) => {
      marker.map = null;
    });
    photoMarkerRefs.current = {};

    // Cluster will be rebuilt via rebuildCluster at the end

    const photoMarkers = [];

    toAdd.forEach((photo) => {
      if (isNil(photo.latitude) || isNil(photo.longitude)) return;

      const url = photo.thumbnailUrl;
      const color = photo.color || '9ECC3B';
      const mapObj = new AdvancedMarkerElement({
        content: buildPhotoContent(url, color),
        position: { lat: photo.latitude, lng: photo.longitude },
        title: photo.name || 'Not Available',
        gmpClickable: true,
      });

      photo['measureType'] = 'photo'
      photo['mapObj'] = function () { return mapObj }

      mapObj.addListener('gmp-click', () => {
        selectedObjectId(photo.id);

        const editFunction = (infoWindow) => {
          collapseLeftToolbar();
          expandLeftToolbar({ dialog: 'edit', editable: photo, mapObj });
          openInfoWindowCloseRef.current = infoWindow;
          openInfoWindowCloseRef.current.close();
          google.maps.event.clearListeners(mapObj, 'gmp-click');
          mapReference.setCenter({ lat: photo.latitude, lng: photo.longitude });
          mapReference.setZoom(17);
          selectedObjectIdNull();
        };

        const clearTheObj = async (value) => {
          try {
            await photoDeleteRequest(value);
            mapObj.map = null;
            sharedCluster.photoMarkers = sharedCluster.photoMarkers.filter(m => m !== mapObj);
            rebuildCluster(mapReference);
          } catch (err) {
            console.error('Error at deleteFunction', err);
          }
        };

        const deleteFunction = (value) => {
          setDeleteMarkerId(value);
          setComfirmRemove(true);
          nulTheMapRefPhoto.current = clearTheObj;
          openInfoWindowCloseRef.current?.close();
          setInfowindowsState(null);
          selectedObjectIdNull();
        };

        const closeFunction = (infoWindow) => {
          openInfoWindowCloseRef.current = infoWindow;
          openInfoWindowCloseRef.current.close();
          setInfowindowsState(null);
          selectedObjectIdNull();
        };

        const updateInfoWindow = (value) => {
          openInfoWindowCloseRef.current = value;
        };

        const dispatchFunction = (value) => {
          storeInfoBox(value);
        };

        createContent(
          { mapReference, mapObj, photo, infoWindow, openInfoWindowClose: openInfoWindowCloseRef.current, token },
          { deleteFunction, closeFunction, editFunction, updateInfoWindow },
          dispatchFunction
        );
      });

      photoMarkerRefs.current[photo.id] = mapObj;
      photoMarkers.push(mapObj);
    });

    sharedCluster.photoMarkers = photoMarkers;
    rebuildCluster(mapReference);
    photoClusterRef.current = sharedCluster.instance;
  };

  useEffect(() => {
    const vendorPhotos = activeVendors.flatMap((id) =>
      vendors[id]?.objects?.photos?.filter((photo) => isNil(photo.latitude) || isNil(photo.longitude) ? false : true) || []
    );

    // Respect the My Content per-type show/hide. Vendor photos are not My Content
    // and stay visible. photoRenderFunction tears down and rebuilds, so dropping
    // user photos here hides them; re-showing re-runs this effect.
    const newPhotos = hiddenContentTypes.includes('photos')
      ? []
      : photos.filter((photo) => {
          if (isNil(photo.latitude) || isNil(photo.longitude)) return false;
          // Per-object "Hide on Map" (WEB-7047).
          if (hiddenContentIds.includes(contentVisibilityKey('photo', photo.id))) return false;
          return true;
        });

    const toAdd = [...newPhotos, ...vendorPhotos];

    if (!isNil(mapReference)) {
      if (toAdd.length > 0) {
        photoRenderFunction(toAdd);
      } else {
        // All photos deleted — clear cluster markers
        Object.values(photoMarkerRefs.current).forEach(m => { m.map = null; });
        photoMarkerRefs.current = {};
        sharedCluster.photoMarkers = [];
        rebuildCluster(mapReference);
      }
    }
  }, [photos, vendors, activeVendors, mapReference, hiddenContentTypes, hiddenContentIds]);

  return comfirmRemove ? (
    <ConfirmRemoval
      cancel={() => setComfirmRemove(false)}
      remove={handleRemoveFunction}
      type="Photo"
    />
  ) : null;
};

const mapStateToProps = (state) => ({
  // Hidden by the global layers eye toggle along with the layers they came from (WEB-7048).
  activeVendors: visibleActiveVendors(state),
  vendors: state.vendors,
  mapReference: typeof state.mapReference === 'function' ? state.mapReference() : null,
  photos: state.photos,
  auth: state.auth,
  infoWindow: state.infoWindow,
  hiddenContentTypes: state.hiddenContentTypes,
  hiddenContentIds: state.hiddenContentIds,
});

const mapDispatchToProps = (dispatch) => ({
  expandLeftToolbar: (props) => dispatch(expandLeftToolbar(props)),
  photoUpdate: (photo) => dispatch(photoUpdate(photo)),
  infoWindowCloseAction: () => dispatch(infoWindowCloseAction()),
  infoWindowOpenAction: (payload) => dispatch(infoWindowOpenAction(payload)),
  photoDeleteRequest: (id) => dispatch(photoDeleteAction(id)),
  disableMapObject: () => dispatch(disableMapObject()),
  collapseLeftToolbar: () => dispatch(collapseLeftToolbar()),
  selectedObjectId: (payload) => dispatch(selectedObjectId(payload)),
  selectedObjectIdNull: () => dispatch(selectedObjectIdNull()),
});

export default connect(mapStateToProps, mapDispatchToProps)(RenderPhotos);
